// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2IKxp","subheader":"ReorderModal_subheader__d-fR7","listWrap":"ReorderModal_listWrap__IIA4e"};